import React from 'react'

const Website = ({website}) => {
  return (
    <div className='website-container'>
        {website.image && <img src={website.image}/>}
        <div className="website-info">
            {website.website && <h1>{website.website}</h1>}
            {website.about && <p>{website.about}</p>}
        </div>
    </div>
  )
}

export default Website